const LockOpenIcon = (props: React.ComponentProps<'svg'>) => {
    return (
        <svg
            {...props}
            xmlns={'http://www.w3.org/2000/svg'}
            width={'24'}
            height={'24'}
            viewBox={'0 0 24 24'}
            fill={'none'}
        >
            <path
                d={
                    // eslint-disable-next-line max-len
                    'M13.5 10.5V6.75a4.5 4.5 0 1 1 9 0v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z'
                }
                stroke={'currentColor'}
                strokeWidth={'1.5'}
                strokeLinecap={'round'}
                strokeLinejoin={'round'}
            />
        </svg>
    );
};

export default LockOpenIcon;
